import type { pdfData } from '@/utils/pdfutils';
import {
  OrderAmendmentPreviewServiceApiFactory,
  type ModelOrderAmendmentPreviewResponse,
  type ModelOrderAmendmentRequest,
} from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export type AmendmentPreviewShareLinkResponse = {
  fileName: string;
  viewUrl: string;
  encodedViewUrl: string;
  shareUrl: string;
  expiresInSeconds: number;
};

export const orderServiceClient = () => {
  const client = createLayupClient();
  return OrderAmendmentPreviewServiceApiFactory(undefined, undefined, client);
};

export const previewAmendment = async (params: ModelOrderAmendmentRequest) => {
  const client = createLayupClient();
  const response = await client.post('v1/order-amendments-preview', params);
  return response.data;
};

export const getAmendmentPreviewById = async (id: string): Promise<ModelOrderAmendmentPreviewResponse> => {
  const client = createLayupClient();
  const response = await client.get(`v1/order-amendments-preview/${id}`);
  return response.data;
};

export const acceptAmendmentPreview = async (id: string) => {
  const client = createLayupClient();
  const response = await client.post(`v1/order-amendments-preview/${id}/accept`);
  return response.data;
};

export const getAmendmentPreviewPdf = async (params: pdfData) => {
  const client = createLayupClient();
  const response = await client.post('/v1/order-amendments-preview/pdf', params, {
    responseType: 'arraybuffer', // <-- expect binary
  });
  return response.data; // ArrayBuffer
};

export const getAmendmentPreviewPdfShareLink = async (
  params: pdfData,
): Promise<AmendmentPreviewShareLinkResponse> => {
  const client = createLayupClient();
  const response = await client.post('/v1/order-amendments-preview/pdf/share', params);
  return response.data;
};
